import { DirectionEnum } from '../types/enums';

const OCTANTS: DirectionEnum[] = [
  DirectionEnum.RIGHT,
  DirectionEnum['TOP-RIGHT'],
  DirectionEnum.TOP,
  DirectionEnum['TOP-LEFT'],
  DirectionEnum.LEFT,
  DirectionEnum['BOTTOM-LEFT'],
  DirectionEnum.BOTTOM,
  DirectionEnum['BOTTOM-RIGHT'],
];

export function directionFromDelta(dx: number, dy: number): DirectionEnum {
  if (dx === 0 && dy === 0) {
    return DirectionEnum.BOTTOM;
  }
  // Map data is Y-down (positive dy = downward) while OCTANTS is laid out for
  // math Y-up — negate dy so a downward move resolves to a BOTTOM direction.
  const angle = Math.atan2(-dy, dx);
  const octant = Math.round((angle / (Math.PI / 4)) % 8);
  return OCTANTS[(octant + 8) % 8];
}
